import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, Input, Popconfirm, Tooltip, message } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import { ROUTES } from 'base/routes/routes';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { CheckStatus, CloseStatus, Filter } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import useDebounce from 'hooks/useDebounce';
import { cloneDeep } from 'lodash';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { dropdownstatus } from 'pages/Components/dataDropDown';
import { SearchModel } from 'pages/model';
import { useTranslation } from 'react-i18next';
import { FaLock } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { CommonModel } from 'services/Main/common_services';
import { ContactSegmentModel } from 'services/Main/contactSegment_services';
import { commonPresenter, commonStore, contactSegmentPresenter, contactSegmentStore } from 'stores/root_store';
import { DATE_FORMAT_POST, PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { useCheckPermission } from 'utils/permissionHelper';
import { getPlantCode } from 'utils/localStorageHelper';

const { RangePicker } = DatePicker;

const createContactSegmentation = () => {
  return observer(() => {
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.contact-seg') + ' - ' + SYSTEM_TITLE;

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();

    // ==================================== STATE ===================================================
    // -----DANH SÁCH COMMON ----------------------------------------------------

    //--- DATA TABLE ------------------------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      customerSegmentationCode: undefined,
      customerSegmentationName: undefined,
      active: true,
      companyCode: getPlantCode()
    });
    // data table báo cáo
    const [dataTable, setDataTable] = useState<ContactSegmentModel[]>([]);
    // Công ty
    const [listCompany, setListCompany] = useState<CommonModel[]>([]);

    // Người tạo
    const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------

    const getDataTable = async (dataSearch: any) => {
      await contactSegmentPresenter.getlistContactSegments(contactSegmentStore, dataSearch);
      if (contactSegmentStore.listContactSegment.isSuccess) {
        const dataTemp = cloneDeep(contactSegmentStore.listContactSegment.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    };

    // Công ty
    const getDataCompany = async () => {
      await commonPresenter.getCompanyByAccount(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCompany(commonStore.commonRespone.data);
      }
    };


    // Lấy  danh sách người tạo
    const getListCreateBy = async (key = '') => {
      await commonPresenter.getListCreateBy(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListCreateBy(commonStore.commonRespone.data);
      }
    };
    const searchCreateBy = useDebounce(getListCreateBy, 500);

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const [columns, setColumns] = useState<ProColumns<ContactSegmentModel>[]>([
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 50,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Mã phân khúc
      {
        title: t('segment.ma-pk'),
        dataIndex: 'contactSegmentationCode',
        key: 'contactSegmentationCode',
        fixed: 'left',
        width: 60,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
        render: (text, record) => (
          <Link
            to={ROUTES.CUSTOMER.CONTACT_SEGMENTATION.DETAIL.LINK + `?type=detail&tabId=${record.id}&tabName=${text}`}
          >
            {text}
          </Link>
        ),
      },
      // Tên phân khúc
      {
        title: t('segment.ten-pk'),
        dataIndex: 'contactSegmentationName',
        key: 'contactSegmentationName',
        fixed: 'left',
        width: 170,
        render: (text, record) => (
          <Link
            to={
              ROUTES.CUSTOMER.CONTACT_SEGMENTATION.DETAIL.LINK +
              `?type=detail&tabId=${record.id}&tabName=${record.contactSegmentationCode}`
            }
          >
            {text}
          </Link>
        ),
      },
      // Số lượng khách hàng
      {
        title: t('segment.sl-kh'),
        dataIndex: 'contactNumber',
        key: 'contactNumber',
        width: 70,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Trạng thái
      {
        title: t('segment.trang-thai'),
        dataIndex: 'status',
        key: 'status',
        width: 80,
        render: (_, record) =>
          record.status ? (
            <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
          ) : (
            <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
          ),
      },
      // công ty
      {
        title: t('search-form.company'),
        dataIndex: 'companyCode',
        key: 'companyCode',
        width: 100,
      },
      // Người tạo
      {
        title: t('segment.nguoi-tao'),
        dataIndex: 'createBy',
        key: 'createBy',
        width: 100,
      },
      //   Ngày tạo
      {
        title: t('segment.ngay-tao'),
        dataIndex: 'createTime',
        key: 'createTime',
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY HH:mm:ss',
        },
        width: 100,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      //   Chức năng
      {
        title: t('Chức năng'),
        dataIndex: 'chucNang',
        key: 'chucNang',
        width: 50,
        render: (text, record) => {
          return (
            <div className='flex items-center justify-center'>
              <Tooltip title='Ngưng hoạt động'>
                <Popconfirm
                  title="Ngưng hoạt động"
                  description="Bạn có chắc muốn ngưng hoạt động?"
                  onConfirm={async () => {
                    await contactSegmentPresenter.deleteContactSegment(contactSegmentStore, record.id);
                    if (contactSegmentStore.deleleContactSegment.isSuccess) {
                      message.success(contactSegmentStore.deleleContactSegment.message)
                      tableRef.current?.reload()
                    }
                  }}
                >
                  <FaLock className='text-[#e74133] cursor-pointer' />
                </Popconfirm>
              </Tooltip>
            </div>
          );
        },
      },
    ]);

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // ============================================ XỬ LÝ TABS =========================================

    // ============================================LƯU MẪU BÁO CÁO =========================================
    const tableRef = useRef<ActionType>();


    useEffect(() => {
      searchCreateBy()
      getDataCompany()
    }, [])

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.contact-seg'),
          },
        ]}
        extras={
          <>
            {/* thêm mới */}
            {/* {checkPermission('CREATE') && (
              <Link to={ROUTES.CUSTOMER.CONTACT_SEGMENTATION.DETAIL.LINK + '?type=create'}>
                <CustomButton type="primary" icon={<Plus className="!fill-white" />}>
                  {t('btn.create')}
                </CustomButton>
              </Link>
            )} */}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<ContactSegmentModel>
            bordered
            columns={columns}
            dataSource={dataTable}
            handleResize={() => { }}
            actionRef={tableRef}
            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
                paging: {
                  ...dataPaging.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });

              if (Object.values(sort).length) {
                setDataPaging({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  },
                });
              }
              return {
                data: data,
                success: contactSegmentStore.listContactSegment.isSuccess,
              };
            }}
            rowKey="stt"
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: contactSegmentStore.listContactSegment.paging?.totalCount,
            }}
            options={{
              setting: false,
              density: false,
              fullScreen: false,
              reload: false,
            }}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          open={open.openDrawer}
          className="lg:!w-[25%]"
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              onClick={() => {
                const createTime = form.getFieldValue('createTime');

                setDataPaging({
                  ...form.getFieldsValue(),
                  fromTime: createTime && createTime[0] ? dayjs(createTime[0])?.format(DATE_FORMAT_POST) : undefined,
                  toTime: createTime && createTime[1] ? dayjs(createTime[1])?.format(DATE_FORMAT_POST) : undefined,
                  paging: { ...dataPaging.paging, pageIndex: 1 },
                });
                form.submit();
                tableRef.current?.reload();
                onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm form={form} column="col-1"
            initialValues={
              {
                active: true,
                companyCode: getPlantCode()
              }}
          >
            {/* mã Phân khúc */}
            <SearchItem name={'contactSegmentationCode'} label={t('segment.ma-pk')}>
              <Input />
            </SearchItem>

            {/* tên phân khúc */}
            <SearchItem name={'contactSegmentationName'} label={t('segment.ten-pk')}>
              <Input />
            </SearchItem>

            {/* Công ty */}
            <SearchItem
              name={"companyCode"}
              label={"Công ty"}
            >
              <CustomSelect
                allowClear
                options={listCompany}
                fieldNames={{ label: "value", value: "key" }}
                showSearch
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>

            {/* Người tạo */}
            <SearchItem name={'createBy'} label={t('search-form.created-by')}>
              <CustomSelect
                options={listCreateBy}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  searchCreateBy(value);
                }}
                allowClear
                showSearch
              />
            </SearchItem>

            {/* Ngày tạo */}
            <SearchItem name={'createTime'} className='!w-full' label={t('search-form.create-date')}>
              <RangePicker
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>

            {/* Trạng thái */}
            <SearchItem name={'active'} label={t('segment.trang-thai')}>
              <CustomSelect options={dropdownstatus} allowClear />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createContactSegmentation;
